function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.047 8C2.894 10.581 5.24 12.435 8 12.435c2.76 0 5.105-1.854 5.953-4.435C13.105 5.419 10.76 3.565 8 3.565 5.24 3.565 2.894 5.419 2.047 8zm-1.024-.16C1.955 4.746 4.725 2.5 8 2.5c3.274 0 6.045 2.246 6.977 5.34a.555.555 0 010 .32C14.045 11.254 11.274 13.5 8 13.5c-3.275 0-6.045-2.246-6.977-5.34a.554.554 0 010-.32zM8 6.403c-.845 0-1.53.715-1.53 1.597S7.154 9.597 8 9.597 9.53 8.882 9.53 8 8.845 6.403 8 6.403zM5.45 8C5.45 6.53 6.59 5.339 8 5.339c1.408 0 2.55 1.191 2.55 2.661S9.408 10.661 8 10.661C6.59 10.661 5.45 9.47 5.45 8z",
  fill: "#2D2D2D"
});
function SvgMostrar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Mostrar.svg";
export { SvgMostrar as ReactComponent };